export default "__VITE_ASSET__f82dc985__$_?component__"